module.exports = __webpack_public_path__ + "static/media/outlook-icon.75fbd474.svg";